















import { defineComponent, ref } from "@vue/composition-api";
import { useAsyncComponent } from "@/hooks/useAsyncComponent";
import { getAllBranchtypes } from "@/api/sap";

export default defineComponent({
  name: "SalesApplicationBranchTypes",
  props: {
    rules: {
      type: String,
      default: "required|max:60",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const { withLoading } = useAsyncComponent({
      root: ctx.root,
      ids: ["SalesApplicationPersonalDetailsStep"],
    });

    const options = ref([
      {
        SPRAS: "D",
        ISTYPE: "ZEVO",
        IND_SECTOR: "Z0000",
        TEXT: "Sonstige",
      },
    ]);

    withLoading(getAllBranchtypes()).then((branchTypes) => {
      if (branchTypes) {
        options.value = branchTypes ?? [];
      }
    });

    return {
      options,
    };
  },
});
